var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArgenCoIconGraphRgb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 408.2 425.2",
    style: {
      enableBackground: "new 0 0 408.2 425.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0graph{fill:#145459;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0graph",
    d: "M336.7,0c-46.2,0-62.6,39.8-68.4,99.6c-0.5,5.2-7.1,6.6-9.5,2c-10.4-19.8-27.3-31.4-54.7-31.4 c-53.3,0-66.9,44.2-70.3,107.3c-0.3,4.9-6.1,6.8-9.1,3c-10.5-13.7-27.1-21.7-53.3-21.7C0,158.8,0,218.4,0,292s0,133.2,71.5,133.2 c1.6,0,3.2,0,4.8-0.1h124.6c1.1,0,2.2,0.1,3.3,0.1c1.4,0,2.8,0,4.2-0.1h124.5c1.2,0.1,2.5,0.1,3.8,0.1c71.5,0,71.5-95.2,71.5-212.6 C408.2,95.2,408.2,0,336.7,0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArgenCoIconGraphRgb);
export default __webpack_public_path__ + "static/media/ArgenCo_icon_graph_rgb.670a698f2fbb2f131b9a7c1c8bbc28f6.svg";
export { ForwardRef as ReactComponent };